module.exports = __webpack_public_path__ + "img/05.968d16dd.jpg";